import { NgZone, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SocialAuthService, SocialUser } from 'angularx-social-login';
import { FacebookLoginProvider, GoogleLoginProvider } from 'angularx-social-login';
import { ElementRef, PLATFORM_ID } from '@angular/core';
import { Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { isPlatformBrowser } from '@angular/common';

import { CommonService } from './../common.service';
import { ApiService } from './../api.service';
import { DataSharingService } from './../data-share.service';
import { Globals } from '../globals';
import { MapsAPILoader } from '@agm/core';
import { HttpClient } from '@angular/common/http';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  options = { autoHide: true, scrollbarMinSize: 100 };
  public globals: Globals;
  public route: any;
  public hide = true;
  public signuphide = true;
  public prev: any;
  // private user: SocialUser;
  private loggedIn: any;
  public loginform: any = {
    email: '',
    password: ''
  };
  public signupuser: any = {name: '', last_name: '', email: '', cel_code: '', cel: '', address: '', location : {
                  zip: '',
                  address: '',
                  lat: '',
                  lng:''
                }, pass: '', terms: false };
  public forgot: any = {email: ''};
  public language: any;
  public loginPopup = true;
  public signinPopup = false;
  public forgotPopup = false;

   public addressFlag = 0;

   public selectedmobilecode: any;
     public ipAddressResp: any;
     public mobilecode_filter: any;

   public mobilecode = [{"country":"Afghanistan","code":"93","iso":"AF"},
{"country":"Albania","code":"355","iso":"AL"},
{"country":"Algeria","code":"213","iso":"DZ"},
{"country":"American Samoa","code":"1684","iso":"AS"},
{"country":"Andorra","code":"376","iso":"AD"},
{"country":"Angola","code":"244","iso":"AO"},
{"country":"Anguilla","code":"1264","iso":"AI"},
{"country":"Antarctica","code":"672","iso":"AQ"},
{"country":"Antigua and Barbuda","code":"1268","iso":"AG"},
{"country":"Argentina","code":"54","iso":"AR"},
{"country":"Armenia","code":"374","iso":"AM"},
{"country":"Aruba","code":"297","iso":"AW"},
{"country":"Australia","code":"61","iso":"AU"},
{"country":"Austria","code":"43","iso":"AT"},
{"country":"Azerbaijan","code":"994","iso":"AZ"},
{"country":"Bahamas","code":"1242","iso":"BS"},
{"country":"Bahrain","code":"973","iso":"BH"},
{"country":"Bangladesh","code":"880","iso":"BD"},
{"country":"Barbados","code":"1246","iso":"BB"},
{"country":"Belarus","code":"375","iso":"BY"},
{"country":"Belgium","code":"32","iso":"BE"},
{"country":"Belize","code":"501","iso":"BZ"},
{"country":"Benin","code":"229","iso":"BJ"},
{"country":"Bermuda","code":"1441","iso":"BM"},
{"country":"Bhutan","code":"975","iso":"BT"},
{"country":"Bolivia","code":"591","iso":"BO"},
{"country":"Bosnia and Herzegovina","code":"387","iso":"BA"},
{"country":"Botswana","code":"267","iso":"BW"},
{"country":"Brazil","code":"55","iso":"BR"},
{"country":"British Indian Ocean Territory","code":"246","iso":"IO"},
{"country":"British Virgin Islands","code":"1284","iso":"VG"},
{"country":"Brunei","code":"673","iso":"BN"},
{"country":"Bulgaria","code":"359","iso":"BG"},
{"country":"Burkina Faso","code":"226","iso":"BF"},
{"country":"Burundi","code":"257","iso":"BI"},
{"country":"Cambodia","code":"855","iso":"KH"},
{"country":"Cameroon","code":"237","iso":"CM"},
{"country":"Canada","code":"1","iso":"CA"},
{"country":"Cape Verde","code":"238","iso":"CV"},
{"country":"Cayman Islands","code":"1345","iso":"KY"},
{"country":"Central African Republic","code":"236","iso":"CF"},
{"country":"Chad","code":"235","iso":"TD"},
{"country":"Chile","code":"56","iso":"CL"},
{"country":"China","code":"86","iso":"CN"},
{"country":"Christmas Island","code":"61","iso":"CX"},
{"country":"Cocos Islands","code":"61","iso":"CC"},
{"country":"Colombia","code":"57","iso":"CO"},
{"country":"Comoros","code":"269","iso":"KM"},
{"country":"Cook Islands","code":"682","iso":"CK"},
{"country":"Costa Rica","code":"506","iso":"CR"},
{"country":"Croatia","code":"385","iso":"HR"},
{"country":"Cuba","code":"53","iso":"CU"},
{"country":"Curacao","code":"599","iso":"CW"},
{"country":"Cyprus","code":"357","iso":"CY"},
{"country":"Czech Republic","code":"420","iso":"CZ"},
{"country":"Democratic Republic of the Congo","code":"243","iso":"CD"},
{"country":"Denmark","code":"45","iso":"DK"},
{"country":"Djibouti","code":"253","iso":"DJ"},
{"country":"Dominica","code":"1767","iso":"DM"},
{"country":"Dominican Republic","code":"1809","iso":"DO"},
{"country":"East Timor","code":"670","iso":"TL"},
{"country":"Ecuador","code":"593","iso":"EC"},
{"country":"Egypt","code":"20","iso":"EG"},
{"country":"El Salvador","code":"503","iso":"SV"},
{"country":"Equatorial Guinea","code":"240","iso":"GQ"},
{"country":"Eritrea","code":"291","iso":"ER"},
{"country":"Estonia","code":"372","iso":"EE"},
{"country":"Ethiopia","code":"251","iso":"ET"},
{"country":"Falkland Islands","code":"500","iso":"FK"},
{"country":"Faroe Islands","code":"298","iso":"FO"},
{"country":"Fiji","code":"679","iso":"FJ"},
{"country":"Finland","code":"358","iso":"FI"},
{"country":"France","code":"33","iso":"FR"},
{"country":"French Polynesia","code":"689","iso":"PF"},
{"country":"Gabon","code":"241","iso":"GA"},
{"country":"Gambia","code":"220","iso":"GM"},
{"country":"Georgia","code":"995","iso":"GE"},
{"country":"Germany","code":"49","iso":"DE"},
{"country":"Ghana","code":"233","iso":"GH"},
{"country":"Gibraltar","code":"350","iso":"GI"},
{"country":"Greece","code":"30","iso":"GR"},
{"country":"Greenland","code":"299","iso":"GL"},
{"country":"Grenada","code":"1473","iso":"GD"},
{"country":"Guam","code":"1671","iso":"GU"},
{"country":"Guatemala","code":"502","iso":"GT"},
{"country":"Guinea","code":"224","iso":"GN"},
{"country":"Guinea-Bissau","code":"245","iso":"GW"},
{"country":"Guyana","code":"592","iso":"GY"},
{"country":"Haiti","code":"509","iso":"HT"},
{"country":"Honduras","code":"504","iso":"HN"},
{"country":"Hong Kong","code":"852","iso":"HK"},
{"country":"Hungary","code":"36","iso":"HU"},
{"country":"Iceland","code":"354","iso":"IS"},
{"country":"India","code":"91","iso":"IN"},
{"country":"Indonesia","code":"62","iso":"ID"},
{"country":"Iran","code":"98","iso":"IR"},
{"country":"Iraq","code":"964","iso":"IQ"},
{"country":"Ireland","code":"353","iso":"IE"},
{"country":"Israel","code":"972","iso":"IL"},
{"country":"Italy","code":"39","iso":"IT"},
{"country":"Ivory Coast","code":"225","iso":"CI"},
{"country":"Jamaica","code":"1876","iso":"JM"},
{"country":"Japan","code":"81","iso":"JP"},
{"country":"Jordan","code":"962","iso":"JO"},
{"country":"Kazakhstan","code":"7","iso":"KZ"},
{"country":"Kenya","code":"254","iso":"KE"},
{"country":"Kiribati","code":"686","iso":"KI"},
{"country":"Kosovo","code":"383","iso":"XK"},
{"country":"Kuwait","code":"965","iso":"KW"},
{"country":"Kyrgyzstan","code":"996","iso":"KG"},
{"country":"Laos","code":"856","iso":"LA"},
{"country":"Latvia","code":"371","iso":"LV"},
{"country":"Lebanon","code":"961","iso":"LB"},
{"country":"Lesotho","code":"266","iso":"LS"},
{"country":"Liberia","code":"231","iso":"LR"},
{"country":"Libya","code":"218","iso":"LY"},
{"country":"Liechtenstein","code":"423","iso":"LI"},
{"country":"Lithuania","code":"370","iso":"LT"},
{"country":"Luxembourg","code":"352","iso":"LU"},
{"country":"Macao","code":"853","iso":"MO"},
{"country":"Macedonia","code":"389","iso":"MK"},
{"country":"Madagascar","code":"261","iso":"MG"},
{"country":"Malawi","code":"265","iso":"MW"},
{"country":"Malaysia","code":"60","iso":"MY"},
{"country":"Maldives","code":"960","iso":"MV"},
{"country":"Mali","code":"223","iso":"ML"},
{"country":"Malta","code":"356","iso":"MT"},
{"country":"Marshall Islands","code":"692","iso":"MH"},
{"country":"Mauritania","code":"222","iso":"MR"},
{"country":"Mauritius","code":"230","iso":"MU"},
{"country":"Mayotte","code":"262","iso":"YT"},
{"country":"Mexico","code":"52","iso":"MX"},
{"country":"Micronesia","code":"691","iso":"FM"},
{"country":"Moldova","code":"373","iso":"MD"},
{"country":"Monaco","code":"377","iso":"MC"},
{"country":"Mongolia","code":"976","iso":"MN"},
{"country":"Montenegro","code":"382","iso":"ME"},
{"country":"Montserrat","code":"1664","iso":"MS"},
{"country":"Morocco","code":"212","iso":"MA"},
{"country":"Mozambique","code":"258","iso":"MZ"},
{"country":"Myanmar","code":"95","iso":"MM"},
{"country":"Namibia","code":"264","iso":"NA"},
{"country":"Nauru","code":"674","iso":"NR"},
{"country":"Nepal","code":"977","iso":"NP"},
{"country":"Netherlands","code":"31","iso":"NL"},
{"country":"Netherlands Antilles","code":"599","iso":"AN"},
{"country":"New Caledonia","code":"687","iso":"NC"},
{"country":"New Zealand","code":"64","iso":"NZ"},
{"country":"Nicaragua","code":"505","iso":"NI"},
{"country":"Niger","code":"227","iso":"NE"},
{"country":"Nigeria","code":"234","iso":"NG"},
{"country":"Niue","code":"683","iso":"NU"},
{"country":"North Korea","code":"850","iso":"KP"},
{"country":"Northern Mariana Islands","code":"1670","iso":"MP"},
{"country":"Norway","code":"47","iso":"NO"},
{"country":"Oman","code":"968","iso":"OM"},
{"country":"Pakistan","code":"92","iso":"PK"},
{"country":"Palau","code":"680","iso":"PW"},
{"country":"Palestine","code":"970","iso":"PS"},
{"country":"Panama","code":"507","iso":"PA"},
{"country":"Papua New Guinea","code":"675","iso":"PG"},
{"country":"Paraguay","code":"595","iso":"PY"},
{"country":"Peru","code":"51","iso":"PE"},
{"country":"Philippines","code":"63","iso":"PH"},
{"country":"Pitcairn","code":"64","iso":"PN"},
{"country":"Poland","code":"48","iso":"PL"},
{"country":"Portugal","code":"351","iso":"PT"},
{"country":"Puerto Rico","code":"1787","iso":"PR"},
{"country":"Qatar","code":"974","iso":"QA"},
{"country":"Republic of the Congo","code":"242","iso":"CG"},
{"country":"Reunion","code":"262","iso":"RE"},
{"country":"Romania","code":"40","iso":"RO"},
{"country":"Russia","code":"7","iso":"RU"},
{"country":"Rwanda","code":"250","iso":"RW"},
{"country":"Saint Barthelemy","code":"590","iso":"BL"},
{"country":"Saint Helena","code":"290","iso":"SH"},
{"country":"Saint Kitts and Nevis","code":"1869","iso":"KN"},
{"country":"Saint Lucia","code":"1758","iso":"LC"},
{"country":"Saint Martin","code":"590","iso":"MF"},
{"country":"Saint Pierre and Miquelon","code":"508","iso":"PM"},
{"country":"Saint Vincent and the Grenadines","code":"1784","iso":"VC"},
{"country":"Samoa","code":"685","iso":"WS"},
{"country":"San Marino","code":"378","iso":"SM"},
{"country":"Sao Tome and Principe","code":"239","iso":"ST"},
{"country":"Saudi Arabia","code":"966","iso":"SA"},
{"country":"Senegal","code":"221","iso":"SN"},
{"country":"Serbia","code":"381","iso":"RS"},
{"country":"Seychelles","code":"248","iso":"SC"},
{"country":"Sierra Leone","code":"232","iso":"SL"},
{"country":"Singapore","code":"65","iso":"SG"},
{"country":"Sint Maarten","code":"1721","iso":"SX"},
{"country":"Slovakia","code":"421","iso":"SK"},
{"country":"Slovenia","code":"386","iso":"SI"},
{"country":"Solomon Islands","code":"677","iso":"SB"},
{"country":"Somalia","code":"252","iso":"SO"},
{"country":"South Africa","code":"27","iso":"ZA"},
{"country":"South Korea","code":"82","iso":"KR"},
{"country":"South Sudan","code":"211","iso":"SS"},
{"country":"Spain","code":"34","iso":"ES"},
{"country":"Sri Lanka","code":"94","iso":"LK"},
{"country":"Sudan","code":"249","iso":"SD"},
{"country":"Suriname","code":"597","iso":"SR"},
{"country":"Svalbard and Jan Mayen","code":"47","iso":"SJ"},
{"country":"Swaziland","code":"268","iso":"SZ"},
{"country":"Sweden","code":"46","iso":"SE"},
{"country":"Switzerland","code":"41","iso":"CH"},
{"country":"Syria","code":"963","iso":"SY"},
{"country":"Taiwan","code":"886","iso":"TW"},
{"country":"Tajikistan","code":"992","iso":"TJ"},
{"country":"Tanzania","code":"255","iso":"TZ"},
{"country":"Thailand","code":"66","iso":"TH"},
{"country":"Togo","code":"228","iso":"TG"},
{"country":"Tokelau","code":"690","iso":"TK"},
{"country":"Tonga","code":"676","iso":"TO"},
{"country":"Trinidad and Tobago","code":"1868","iso":"TT"},
{"country":"Tunisia","code":"216","iso":"TN"},
{"country":"Turkey","code":"90","iso":"TR"},
{"country":"Turkmenistan","code":"993","iso":"TM"},
{"country":"Turks and Caicos Islands","code":"1649","iso":"TC"},
{"country":"Tuvalu","code":"688","iso":"TV"},
{"country":"U.S. Virgin Islands","code":"1340","iso":"VI"},
{"country":"Uganda","code":"256","iso":"UG"},
{"country":"Ukraine","code":"380","iso":"UA"},
{"country":"United Arab Emirates","code":"971","iso":"AE"},
{"country":"United Kingdom","code":"44","iso":"GB"},
{"country":"United States","code":"1","iso":"US"},
{"country":"Uruguay","code":"598","iso":"UY"},
{"country":"Uzbekistan","code":"998","iso":"UZ"},
{"country":"Vanuatu","code":"678","iso":"VU"},
{"country":"Vatican","code":"379","iso":"VA"},
{"country":"Venezuela","code":"58","iso":"VE"},
{"country":"Vietnam","code":"84","iso":"VN"},
{"country":"Wallis and Futuna","code":"681","iso":"WF"},
{"country":"Western Sahara","code":"212","iso":"EH"},
{"country":"Yemen","code":"967","iso":"YE"},
{"country":"Zambia","code":"260","iso":"ZM"},
{"country":"Zimbabwe","code":"263","iso":"ZW"}];


  @ViewChild('lemail') lemail!: ElementRef;
  @ViewChild('lpassword') lpassword!: ElementRef;
  @ViewChild('sname') public sname!: ElementRef;
  @ViewChild('slname') public slname!: ElementRef;
  @ViewChild('semail') public semail!: ElementRef;
   @ViewChild('secel') public secel!: ElementRef;
  @ViewChild('seaddress') public seaddress!: ElementRef;
  @ViewChild('spass') public spass!: ElementRef;
  @ViewChild('femail') public femail!: ElementRef;



  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    public dialogRef: MatDialogRef < LoginComponent > ,
    private spinner: NgxSpinnerService,
    public snackBar: MatSnackBar,
    @Inject(PLATFORM_ID) private platformId: Object,
    private authService: SocialAuthService,
    public router: Router,
    private dataSharingService: DataSharingService,
    private comservice: CommonService,
    private apiservice: ApiService,
    globals: Globals,
     private mapsAPILoader: MapsAPILoader,
      private ngZone: NgZone,
  ) {
    this.globals = globals;
    this.language = this.globals.LANGUAGE[this.globals?.LANG_ID as keyof typeof this.globals.LANGUAGE];
  }

   placeChanged() {
    this.addressFlag = 0;
  }

  ngOnInit() {
    let uid: any;
    uid = this.comservice.getFromLocal('userId');
    let cartDish: any;
    cartDish = this.comservice.getService('cartDetails');
    let businessDetails: any;
    businessDetails = this.comservice.getService('businessDetails');
    if (cartDish !== undefined) {
      if (cartDish.length > 0 && uid > 0) {
        this.router.navigate(['/' + businessDetails.slug]);
      }
    } else {
      if (uid > 0) {
        this.router.navigate(['/']);
      }
    }

    this.prev = this.comservice.getService('prevroute');
    $('.button').click(() => {
      let buttonId: any;
      buttonId = $(this).attr('id');
      $('#modal-container').removeAttr('class').addClass(buttonId);
      $('body').addClass('modal-active');
    });

    $('.close-modal').click(function () {
      $('#modal-container').addClass('out');
      $('body').removeClass('modal-active');
    });

    this.googelLoad();
    this.GetIPLocation();
  }

  GetIPLocation(){
    this.http.get(' https://api.ipify.org/?format=json').subscribe((ipOfNetwork: any) => {
      //console.log(ipOfNetwork);
      this.http.get('https://api.country.is/' + ipOfNetwork['ip']).subscribe((resip) => {
        console.log(resip)
             this.ipAddressResp = resip;
             this.mobilecode_filter = this.mobilecode.find(item => item.iso == this.ipAddressResp.country);
             //console.log(result);
            this.selectedmobilecode= this.mobilecode_filter.code;  
      });
    });
  }

  googelLoad() {

    // set current position
    this.mapsAPILoader.load().then(
      () => {
        // types: [], componentRestrictions: { country: 'IN' }
        let autocomplete: any;
        autocomplete = new google.maps.places.Autocomplete(this.seaddress.nativeElement, {});

        autocomplete.addListener('place_changed', () => {
          this.ngZone.run(() => {
            let place: google.maps.places.PlaceResult = autocomplete.getPlace();
            if (place.geometry === undefined || place.geometry === null) {
              return;
            } else {
              
              for (let i = 0; i < place.address_components.length; i++) {
                for (let j = 0; j < place.address_components[i].types.length; j++) {
                  if (place.address_components[i].types[j] === 'postal_code') {
                    this.signupuser.location.zip = place.address_components[i].long_name;
                  }
                }
              }
              this.signupuser.location.address = place.formatted_address;
              this.signupuser.address = place.formatted_address;
              this.signupuser.location.lat = place.geometry.location.lat();
              this.signupuser.location.lng = place.geometry.location.lng();
              this.addressFlag = 1;
            }
          });
        });
      }
    );
    this.spinner.hide();
  }

  initiateSocial(val: any) {
    this.authService.authState.subscribe((user) => {
      if (user !== null) {
        let name;
        name = user.name.split(' ');
        let socialuser;
        socialuser = {
          name: name[0],
          lastname: name[1],
          email: user.email,
          image: user.photoUrl,
          type: 1
        };
        this.apiservice.getSocialLogin(socialuser).subscribe((res: any) => {
          if (res.status) {
            this.comservice.setService('user-details', res.result);
            this.comservice.saveInLocal('user-details', res.result);
            this.comservice.saveInLocal('userId', res.result.id);
            this.apiservice.getLoginCheck(res.result.id).subscribe((result: any) => {
              this.dataSharingService.isUserLoggedIn.next(true);
              let prevroute: any;
              prevroute = this.comservice.getService('prevroute');
              if (prevroute === 'checkout') {
                this.router.navigate(['/' + prevroute]);
              } else {
                this.onNoClick();
              }
            });
          } else {
            this.snackBar.open(res.message, this.language.TOAST_OK, {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'top'
            });
          }
        });
      }
    });
    if (val === 1) {
      this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
    }
    if (val === 2) {
      this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
    }
  }
  signInWithGoogle(): void {
    this.initiateSocial(1);
  }

  signInWithFB(): void {
    this.initiateSocial(2);
  }

  onLoginSubmit() {
    if (this.loginform.email === '') {
      this.snackBar.open(this.language.ENTER_YOUR_EMAIL, this.language.TOAST_OK, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
      if (isPlatformBrowser(this.platformId)) {
        this.lemail.nativeElement.focus();
      }
    } else if (this.loginform.password === '') {
      this.snackBar.open(this.language.ENTER_PASSWORD, this.language.TOAST_OK, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
      if (isPlatformBrowser(this.platformId)) {
        this.lpassword.nativeElement.focus();
      }
    }
    this.apiservice.getLogin(this.loginform.email, this.loginform.password).subscribe((res: any) => {
      if (res.status) {
        this.comservice.setService('user-details', res.result);
        this.comservice.saveInLocal('user-details', res.result);
        this.comservice.saveInLocal('userId', res.result.id);
        this.apiservice.getLoginCheck(res.result.id).subscribe((result: any) => {

        });
        this.dataSharingService.isUserLoggedIn.next(true);
        let prevroute: any;
        prevroute = this.comservice.getService('prevroute');
        if (prevroute === 'checkout') {
          this.router.navigate(['/' + prevroute]);
        }
        this.onNoClick();
      } else {
        this.snackBar.open(res.message, this.language.TOAST_OK, {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top'
        });
      }
    });
  }
  onNoClick() {
    this.dialogRef.close();
  }
  changeToLogin() {
    this.loginPopup = true;
    this.signinPopup = false;
    this.forgotPopup = false;
  }
  changeTosignUp() {
    this.loginPopup = false;
    this.signinPopup = true;
    this.forgotPopup = false;
  }
    numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  onSignUpSubmit() {
    if (this.signupuser.name === '') {
      this.snackBar.open(this.language.ENTER_FIRST_NAME, this.language.TOAST_OK, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
      if (isPlatformBrowser(this.platformId)) {
        this.sname.nativeElement.focus();
      }
      return false;
    }
    if (this.signupuser.last_name === '') {
      this.snackBar.open(this.language.ENTER_YOUR_LAST_NAME, this.language.TOAST_OK, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
      if (isPlatformBrowser(this.platformId)) {
        this.slname.nativeElement.focus();
      }
      return false;
    }
    if (this.signupuser.email === '') {
      this.snackBar.open(this.language.ENTER_YOUR_EMAIL, this.language.TOAST_OK, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
      if (isPlatformBrowser(this.platformId)) {
        this.semail.nativeElement.focus();
      }
      return false;
    }
    let atpos;
    atpos = this.signupuser.email.indexOf('@');
    let dotpos;
    dotpos = this.signupuser.email.lastIndexOf('.');
    if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= this.signupuser.email.length) {
      this.snackBar.open(this.language.ENTER_VALID_EMAIL_ADDRESS, this.language.TOAST_OK, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
      if (isPlatformBrowser(this.platformId)) {
        this.semail.nativeElement.focus();
      }
      return false;
    }


    if (this.signupuser.cel === '') {
      this.snackBar.open(this.language.ENTER_YOUR_MOBILE, this.language.TOAST_OK, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
      if (isPlatformBrowser(this.platformId)) {
        this.secel.nativeElement.focus();
      }
      return false;
    }

     if (this.addressFlag === 0) {
      this.snackBar.open(this.language.ENTER_CORRECT_ADDRESS, this.language.TOAST_OK, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
      return false;
    }

    if (this.signupuser.address === '') {
      this.snackBar.open(this.language.ENTER_YOUR_ADDRESS, this.language.TOAST_OK, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
      if (isPlatformBrowser(this.platformId)) {
        this.seaddress.nativeElement.focus();
      }
      return false;
    }



    if (this.signupuser.pass === '') {
      this.snackBar.open(this.language.ENTER_YOUR_PASSWORD, this.language.TOAST_OK, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
      if (isPlatformBrowser(this.platformId)) {
        this.spass.nativeElement.focus();
      }
      return false;
    }
    if (this.signupuser.pass.length < 6) {
      this.snackBar.open(this.language.ENTER_YOUR_PASSWORD_LENGTH, this.language.TOAST_OK, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
      if (isPlatformBrowser(this.platformId)) {
        this.spass.nativeElement.focus();
      }
      return false;
    }
    if (this.signupuser.terms === false) {
      this.snackBar.open(this.language.CHECK_PRIVACY_TERMS, this.language.TOAST_OK, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
      return false;
    }

    this.signupuser.cel_code = this.selectedmobilecode;
  

    /*console.log(this.signupuser);

    return false;*/


    this.apiservice.setSignUp(this.signupuser).subscribe((res: any) => {
      if (res.status) {
        this.comservice.setService('user-details', res.result);
        this.comservice.saveInLocal('user-details', res.result);
        this.comservice.saveInLocal('userId', res.result.id);
        this.apiservice.getLoginCheck(res.result.id).subscribe((rest: any) => {
          this.dataSharingService.isUserLoggedIn.next(true);
          let prevroute: any;
          prevroute = this.comservice.getService('prevroute');
          if (prevroute === 'checkout') {
            this.router.navigate(['/' + prevroute]);
          }
          this.onNoClick();
        });

        this.dataSharingService.isUserLoggedIn.next(true);
        this.onNoClick();

      } else {
       
        this.snackBar.open(res.message, this.language.TOAST_OK, {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top'
        });
      }
    });
  }
  changeToForgotPass() {
    this.loginPopup = false;
    this.signinPopup = false;
    this.forgotPopup = true;
  }
  onForgotSubmit() {
    if (this.forgot.email === '') {
      this.snackBar.open(this.language.ENTER_YOUR_EMAIL, this.language.TOAST_OK, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
      if (isPlatformBrowser(this.platformId)) {
        this.femail.nativeElement.focus();
      }
      return false;
    }
    let atpos;
    atpos = this.forgot.email.indexOf('@');
    let dotpos;
    dotpos = this.forgot.email.lastIndexOf('.');
    if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= this.forgot.email.length) {
      this.snackBar.open(this.language.ENTER_VALID_EMAIL_ADDRESS, this.language.TOAST_OK, {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
      if (isPlatformBrowser(this.platformId)) {
        this.femail.nativeElement.focus();
      }
      return false;
    }
    this.apiservice.getForgot(this.forgot).subscribe((res: any) => {
      if (res.status) {
        this.snackBar.open(res.message, this.language.TOAST_OK, {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top'
        });
        this.onNoClick();
        this.forgot = { email: '' };
      } else {
        this.snackBar.open(res.message, this.language.TOAST_OK, {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top'
        });
      }
    });
  }
  guestCheckOut() {
    this.onNoClick();
    this.router.navigate(['/checkout']);
    this.comservice.scrollTop();
  }
}
